const AppStoreLinks = {
  apple: "https://apps.apple.com/gb/app/is-it-peak/id1671171132",
  android:
    "https://play.google.com/store/apps/details?id=com.francisleigh.thatispeak",
};

export default AppStoreLinks;
